import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import arraySort from 'array-sort'

export default class Search extends Component {
  constructor () {
    super()
    this.handleSelectChangeBound = this.handleSelectChange.bind(this)
  }

  render () {
    const { frameworkSkills } = this.props

    return (
      <Select
        searchable
        clearable
        options={this.mapList(frameworkSkills)}
        onChange={this.handleSelectChangeBound}
        placeholder="Select skills to link."
      />
    )
  }

  handleSelectChange (value) {
    this.props.onSkillSelect(value)
  }

  mapList (skills) {
    const values = skills.map(skill => ({
      id: skill.id,
      value: skill.id,
      label: skill.name
    }))

    return arraySort(values, ['label'])
  }
}

Search.propTypes = {
  frameworkSkills: PropTypes.array.isRequired,
  onSkillSelect: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/quest/skills/Search.js